import { createRoot } from 'react-dom/client';
import * as serviceWorker from "./serviceWorker";
import "./main.scss";


//context to stable the login and auth system


import App from "./App"
//const vote = `${user ? "Vote" : "Login"}`;
const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App tab="home" />);
// Disable service worker - server returns HTML instead of service-worker.js
serviceWorker.unregister();
